<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Factor</th>
                    <th>Weight</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row) in tableFactors">
                    <td>{{row.number}}</td>
                    <td>{{row.name}}</td>
                    <td><input class="weightFactor" :data-id="row.id" @change="updateWeight($event)" type="number" min="0" max="100" :value="row.weight"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        data()  {
            return {
                tableFactors : [],
                sumWeights : 0
            }
        },
        props : {

            urlBaseChart: {
                type: String,
                default: "",
                required : true
            },
        },

        methods: {
            updateWeight(event){
                console.log(event.target.value,$(event.target).data('id'));
                //base-charts/factors/{base_chart_factor}/update-weight
                let params ={
                    _method:"PUT",
                    baseChartFactor :{
                        weight : event.target.value,
                        required : 1
                    }
                };
                axios.post('/base-charts/factors/'+$(event.target).data('id')+'/update-weight', params)
                    .then((response) => {
                        Vue.$toast.open({
                            message: 'Save Complete!',
                            type: 'success',
                            position: 'top-right'
                        });
                    }
                );
            },
            getTableFactors(){

                axios.get(this.urlBaseChart)
                    .then((response) => {
                        console.log(this.urlBaseChart)
                        this.tableFactors =response.data.data;


                    });
            }
        },
        mounted() {
            this.getTableFactors();
            /*
            $.each( this.tableFactors, function( index, row ) {
                console.log(row.weight);
                this.sumWeights += row.weight;
                console.log(this.sumWeights);
            });*/

        },


    }
</script>

